export default "__VITE_ASSET__b9a82150__"